/**
 * Warehouse (KMAG) codes and display names.
 * When name is null, the UI shows the code until a name is provided.
 */
export const WAREHOUSE_ENTRIES: { code: string; name: string | null }[] = [
  { code: "MD", name: null },
  { code: "MDR", name: "MAGAZINA DURRES" },
  { code: "MDR1", name: null },
  { code: "ME", name: "MAGAZINA ELBASAN" },
  { code: "MF", name: "MAGAZINA FIER" },
  { code: "MF1", name: null },
  { code: "MGJ", name: "MAGAZINA GJIROKASTER" },
  { code: "MGJP", name: null },
  { code: "MI", name: "MAGAZINA KAMEZ" },
  { code: "MIP", name: null },
  { code: "MK", name: "MAGAZINA TIRANE" },
  { code: "ML", name: "MAGAZINA LUSHNJE" },
  { code: "MLP", name: null },
  { code: "MO", name: "MAGAZINA KORCE" },
  { code: "MOP", name: null },
  { code: "MSH", name: "MAGAZINA SHKODER" },
  { code: "MSHP", name: null },
  { code: "MT", name: null },
  { code: "MV", name: "MAGAZINA VLORE" },
  { code: "MVP", name: null },
  { code: "MZ", name: "MAGAZINA LEZHE" },
  { code: "MZP", name: null },
];

export const WAREHOUSE_CODES = WAREHOUSE_ENTRIES.map((w) => w.code);

/** Labels shown in admin zone / basket warehouse pickers */
export const WAREHOUSE_ZONE_OPTIONS = WAREHOUSE_ENTRIES.map(
  (w) => w.name || w.code
);

const codeToName = new Map(
  WAREHOUSE_ENTRIES.map((w) => [w.code, w.name] as const)
);

const labelToCode = new Map<string, string>();
for (const w of WAREHOUSE_ENTRIES) {
  labelToCode.set(w.code, w.code);
  if (w.name) {
    labelToCode.set(w.name, w.code);
    labelToCode.set(w.name.toLowerCase(), w.code);
  }
}

// Legacy zone labels from the previous 3-warehouse setup
for (const [label, code] of [
  ["Magazina Fier", "MF"],
  ["Magazina Tirane (Bulevardi)", "MK"],
  ["Magazina Tirane(Bulevardi)", "MK"],
  ["Magazina Tirane\u00a0(Bulevardi)", "MK"],
  ["Magazina Kashar", "MK"],
] as const) {
  labelToCode.set(label, code);
  labelToCode.set(label.toLowerCase(), code);
}

export function getWarehouseLabel(code: string | null | undefined): string {
  if (!code) return "";
  const trimmed = String(code).trim();
  const name = codeToName.get(trimmed);
  return name || trimmed;
}

export function getWarehouseCode(labelOrCode: string | null | undefined): string {
  if (!labelOrCode) return "";
  const trimmed = String(labelOrCode).trim();
  return (
    labelToCode.get(trimmed) ||
    labelToCode.get(trimmed.toLowerCase()) ||
    trimmed
  );
}

export function isKnownWarehouseCode(code: string | null | undefined): boolean {
  if (!code) return false;
  return codeToName.has(String(code).trim());
}
